export default {
  EventCalendar: {
    TitleLogin: 'Đăng nhập Microsoft Teams',
    DescriptionLogin:
      'Sử dụng tài khoản Microsoft Teams cán bộ tin học của trường đã cấp hoặc tài khoản cá nhân của bạn.',
    SetupDescription:
      'Bạn chưa có liên kết với phòng học nào, Vui lòng thêm phòng học để có thể đặt lịch học',
    CreateRoom: 'Đặt lịch',
    CreateRoomTitle: 'Tạo lịch học',
    InformationRoom: 'Thông tin lịch học',
    AddRoom: 'Thêm phòng học',
    CalendarName: 'Tên buổi học',
    CalendarPlaceholder: 'Nhập tên buổi học',
    EnterDescription: 'Nhập mô tả thêm về buổi học...',
    Subject: 'Môn học',
    ClassPlaceholder: 'Chọn lớp',
    LoopCalendar: 'Lặp lại định kỳ',
    FinishDate: 'Ngày kết thúc',
    StudyDate: 'Thời gian học',
    Monday: 'Thứ 2',
    Tuesday: 'Thứ 3',
    Wednesday: 'Thứ 4',
    Thursday: 'Thứ 5',
    Friday: 'Thứ 6',
    Saturday: 'Thứ 7',
    Sunday: 'Chủ nhật',
    MondayShortcut: 'T2',
    TuesdayShortcut: 'T3',
    WednesdayShortcut: 'T4',
    ThursdayShortcut: 'T5',
    FridayShortcut: 'T6',
    SaturdayShortcut: 'T7',
    SundayShortcut: 'CN',
    TitleEventCalendar: 'Học trực tuyến {subjectContent} - {classContent}',
    DeleteSingleDay: 'Xóa một ngày',
    DeleteMultipleDay: 'Xóa tất cả ngày lặp',
    EditSingleDay: 'Sửa một ngày',
    EditMultipleDay: 'Sửa tất cả ngày lặp',
    DurationMinute: '({timeMinute} phút)',
    DurationHour: '({timeHour} giờ)',
    DurationHourMinute: '({timeHour} giờ {timeMinute} phút)',
    TitleDeleteEvent:
      'Bạn có chắc muốn xóa lịch học <b>{titleEvent}</b> không?',
    DeleteSuccess: 'Bạn đã xóa lịch học thành công.',
    WarningAddExit: 'Lịch vừa {action} trùng với <b>{contentCalendar}</b>',
    Create: 'tạo',
    Modify: 'sửa',
    ErrorTime: 'Vui lòng chọn giờ kết thúc lớn hơn giờ bắt đầu.<br>',
    ErrorDate: 'Vui lòng chọn ngày kết thúc lớn hơn ngày bắt đầu.<br>',
    ErrorDayRepeat: 'Vui lòng chọn ngày lặp lại định kỳ. <br>',
    TimeExist: '{title}',
    Test: 'Thứ',
    TeacherName: 'Giáo viên: {teacherName}',
    SubjectName: 'Môn: {subjectName}',
    ClassName: 'Lớp: {className}',
    DurationName: 'Thời lượng: {duration}',
    DurationMinuteDetail: '{timeMinute} phút',
    DurationHourDetail: '{timeHour} giờ',
    DurationHourMinuteDetail: '{timeHour} giờ {timeMinute} phút',
    ListCalendarEmpty: 'Chưa có lịch nào',
    ListCalendarEmptyDefault:
      'Bạn chưa có lịch dạy nào 7 ngày tới, chọn Đặt lịch <br/> để bắt đầu tạo lịch học cho lớp',
    TeacherTitle: 'Giáo viên:',
    SubjectTitle: 'Môn:',
    ClassTitle: 'Lớp:',
    MeetingRoom: 'Phòng:',
    StartTime: 'Thời gian:',
    DurationTitle: 'Thời lượng:',
    Description: 'Mô tả:',
    Happenning: 'Đang diễn ra',
    LeftTime: 'Còn ',
    SetupClassroom: 'Thiết lập phòng học',
    SetupClassroomOnline: 'Thiết lập phòng học trực tuyến',
    PersonalAccount: 'Tài khoản cá nhân',
    EducationAccount: 'Tài khoản giáo dục',
    EditLink: 'Sửa liên kết',
    DestroyLink: 'Hủy liên kết',
    ListRoom: 'Danh sách phòng học',
    GoHome: 'Tới trang chủ',
    SetupCalendar: 'Đặt lịch học',
    ConnectOnlineZoom: 'Liên kết phòng học',
    TitleHelp:
      'Bạn đang sử dụng tài khoản {platformName} cá nhân, hãy dán đường dẫn phòng học vào bên dưới để hoàn thành thiết lập',
    PasteLinkRoom: 'Dán đường dẫn phòng học ...',
    Meeting: 'Phòng học',
    SystemLogin: 'Vui lòng đăng nhập lại tài khoản {platformName} của bạn',
    UrlNotFound: 'Đường dẫn không tồn tại',
    MessageConfirmDeleteRoom:
      'Bạn có chắc muốn hủy liên kết phòng <b>{platformName}</b> không?',
    DeleteRoomSuccess: 'Xóa phòng học thành công',
    AddRoomSuccess: 'Thêm phòng học thành công',
    EditRoomSuccess: 'Sửa phòng học thành công',
    ManageCalendar: 'Quản lý lịch',
    ListCalendar: 'Danh sách lịch',
    ViewHelp: 'Xem hướng dẫn',
    SuccessConnectRoom: 'Liên kết phòng thành công',
    ErrorConnectRoom: 'Liên kết phòng không thành công, vui lòng thử lại',
    ErrorAddCalendar: 'Lưu lịch học không thành công, vui lòng thử lại',
    TitleSuccessPlatform:
      'Bạn đang sử dụng tài khoản {platformName},<br> đường dẫn đến phòng học đã được tự động liên kết',
    SelectAccountType: 'Lựa chọn loại tài khoản {platformName}',
    TeamsAccountSingle: 'Tài khoản cá nhân',
    TeamsAccountOrganization: 'Tài khoản giáo dục {isUseOTPRO}',
    DescriptionTeamsAccountSingle:
      'Trải nghiệm miễn phí bằng cách <br/> sử dụng đường dẫn tham gia lớp học',
    DescriptionTeamsAccountOrganization:
      'Tổ chức lớp học trực tuyến <br/> không giới hạn thời gian và số lượng học sinh',
    ZoomsAccountSingle: 'Tài khoản thường (Basic)',
    ZoomsAccountOrganization: 'Tài khoản cao cấp (Pro)',
    DescriptionZoomsAccountSingle:
      'Trải nghiệm miễn phí bằng cách <br/> sử dụng đường dẫn tham gia lớp học',
    DescriptionZoomsAccountOrganization:
      'Tổ chức lớp học trực tuyến <br/> với nhiều tiện ích hỗ trợ dạy học trực tuyến',
    ErrorUrlMeetingApp: 'Đường dẫn phòng học không hợp lệ, vui lòng thử lại',
    ReLogin:
      'Phiên đăng nhập tài khoản <b>{platformName}</br> của bạn đã hết, vui lòng đăng nhập lại để tiếp tục sử dụng',
    OTPRO: '(Gói Ôn tập 2)'
  }
}
